import PropTypes from 'prop-types';
import styles from './add-button.module.less';
import ButtonSizable from '../button-sizable/ButtonSizable';

const AddButton = ({ children, onClick, icon = 'fa-plus', ...props }) => (
    <div onClick={onClick} className={styles.buttonContainer}>
        <ButtonSizable className={styles.button} {...props}>
            <i className={`fa-solid ${icon} ${styles.plus}`} />
        </ButtonSizable>
        <div className={[styles.text, props.disabled ? styles.disabled : ''].join(' ')}> {children}</div>
    </div>
);

AddButton.propTypes = {
    children: PropTypes.node.isRequired,
};

export default AddButton;
